import { TitleBar } from "./Model";
import React, { useState } from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";

const NpsScale = ({ info, onChange, value = [] }) => {
  let col = info.answerList || [];
  const handleClick = (colItem) => {
    onChange([{ answerId: colItem.id, checked: true, position: colItem.position, source: colItem }]);
  };

  return (
    <div className="nps-scale">
      <div className="scale-title-bar">
        <div className="first_firstlabel">{col[0].label}</div>
        <div className="first_lastlabel">{col[col.length - 1].label}</div>
      </div>
      <div className={`scale-bar position-${value[0]?.position}`}>
        {col.map((item, i) => (
          <div key={item.id} className="scale-item" onClick={() => handleClick(item)}>
            {item.text}
          </div>
        ))}
      </div>
    </div>
  );
};

const PcNpsScale = ({ info, onChange, value = [] }) => {
  let col = info.answerList || [];
  const [hoverIndex, setHoverIndex] = useState();
  const handleClick = (colItem) => {
    onChange([{ answerId: colItem.id, checked: true, position: colItem.position, source: colItem }]);
  };
  const firstTxt = col[0].label || col[0].text;
  const lastTxt = col[col.length - 1].label || col[col.length - 1].text;

  return (
    <div className="nps-scale">
      <div className="scale-bar-box">
        <div className="txt">{firstTxt}</div>
        <div className={`scale-bar position-${hoverIndex || value[0]?.position}`}>
          {col.map((item, i) => (
            <div
              className="scale-item"
              onMouseEnter={() => setHoverIndex(i.toString())}
              onMouseLeave={() => setHoverIndex(undefined)}
              onClick={() => handleClick(item)}
              key={i}
            >
              {i}
            </div>
          ))}
        </div>
        <div className="txt">{lastTxt}</div>
      </div>
    </div>
  );
};

const NpsViews = (props) => {
  const { info } = props;
  const { isMobile } = useSelector((state) => state.app);
  return (
    <div className="components-nps-views">
      <TitleBar info={info}></TitleBar>
      <Form.Item name={["postAnswer", info.position]}>
        {isMobile ? <NpsScale info={info} /> : <PcNpsScale info={info} />}
      </Form.Item>
    </div>
  );
};

export default NpsViews;
